require('bootstrap-treeview/dist/bootstrap-treeview.min');
var Marionette = require('backbone.marionette');

var PersonDataView = require('./person-data-view');
var PersonForm = require('./person-form-view');
var Person = require('../../models/person-model');

var RelationsFormView = require('../relations/relations-form');
var RelationsListView = require('../relations/relations-list-view');
var PermissionsTableView = require('../permissions/permissions-table-view');
var PermissionFormView = require('../permissions/permission-form');

var ReverseRelationsCollection = require('../../collections/reverse-relations-collection');
var PermissionsCollection = require('../../collections/permissions-collection');
var CommonUtils = require('../../utils/common-utils.js');

var ContactsTableView = require('../contacts/contacts-table-view');
var ContactFormView = require('../contacts/contact-form');
var ContactsCollection = require('../../collections/contacts-collection');

var AddressTableView = require('../contacts/address-table-view');
var AddressesFormView = require('../contacts/address-form');

var RepresentativesTableView = require('../contacts/representatives-table-view');
var RepresentativeFormView = require('../contacts/representative-form');

var CommentFormView = require('../comments/comment-form');
var CommentsTableView = require('../comments/comments-table-view');

var ExternalIdsView = require("../common/external-ids-view");

var MedicalRecords = require('../medicals/medical-profile');
var DiseasesView = require('../medicals/diseases-view');
var PatientDocuments = require('../medicals/patient-documents-view');
var DeterminationOfNeedRevisedView = require('../med-forms/determination-of-need-revised-view');
var PatientSources = require('../medicals/patient-sources-view');
var PatientImmunizations = require('../medicals/patient-immunizations-view');
var PatientDicoms = require('../medicals/patient-dicoms-view');
var PatientVitals = require('../medicals/patient-vitals-view');

var PersonOrganizationsView = require('./person-organizations-view');

var Radio = require('backbone.radio');
var sessionChannel = Radio.channel('session');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');


var PersonView = Marionette.View.extend({
    template: require('../../templates/persons/person.html'),
    regions: {
        personData: '#person-data',
        personForm: '#person-form',
        editSection: '#edit-section',
        organizationRelations: '#organization-relations',
        addOrganizationRelation: '#add-organization-relation',
        permissions: '#permissions',
        addPermission: '#add-permission',
        contacts: '#contacts',
        contactForm: '#contact-form',
        addresses: '#addresses',
        addressForm: '#address-form',
        representatives: '#representatives',
        representativeForm: '#representative-form',
        medicalRecords: '#medical-records-container',
        diseasesRegion: '#diseases-container',
        documentsRegion: '#documents-container',
        appendixKKRegion: '#appendix-kk-container',
        sourcesRegion: '#sources-container',
        immunizationsRegion: '#immunizations-container',
        dicomsRegion: '#dicoms-container',
        vitalsRegion: '#vitals-container',
        comments: '#comments',
        addComment: '#add-comment',
        externalsIdsRegion: '#external-ids',
        organizationsRegion: '#organizations'
    },

    ui: {
        personData: '#person-data',
        saveBtn: '#save-person',
        leftTabs: '.left-tabs',
        saveAppendixKKBtn: '#save-appendix-kk',
        contactForm: '#contact-form',
        commentsCount: '#comments-count',
        representativeForm: "#representative-form"
    },

    events: {
        'click #edit-data': 'toggleEdit',
        'click #cancel-edit': 'toggleEdit',
        'click #save-person': 'saveChanges',
        'click @ui.saveAppendixKKBtn': 'onSaveAppendixKK',
        'comment:count:changed': 'onCommentCountChanged'
    },

    childViewEvents: {
        'permission:saved': 'permissionSaved',
        'person:save:valid': 'savePersonBtnEnableOrDisable',
        'on:contact:action': 'onContactAction',
        'on:contact:saved': 'onContactSaved',
        'on:address:action': 'onAddressAction',
        'on:address:saved': 'onAddressSaved',
        'on:representative:action': 'onRepresentativeAction',
        'on:representative:saved': 'onRepresentativeSaved',
        'med:record:created': 'reRenderMedProfile',
        'show:subtabs': 'showLeftSubTabs',
        'changed-don-r': 'onDonRChanged',
        'contact:hover': 'onContactHover',
        'address:hover': 'onAddressHover',
        'representative:hover': 'onRepresentativeHover',
        'comment:added': 'onCommentAdded',
        'comment:count:changed': 'onCommentCountChanged',
        'on:cancel:comment:send': 'onCancelCommentSend',
        'on:edit:comment': 'onEditComment',
        'comment:updated': 'onCommentUpdated',
        'on:new:comment': 'onNewComment',
        'on:save:externalids': 'onSavePersonExternalIds',
        'on:cancel:externalids': 'onCancelPersonExternalIds'
    },

    userCanEdit: undefined,

    templateContext: function () {
        var that = this;
        return {
            canEdit: function () {
                return that.canEdit() || that.isItOwn();
            }
        }
    },


    initialize: function (options) {
        this.model = options.model;
        this.model.view = this;
        this.model.on('invalid', this.onErrors);
        this.parentOrganizationsRelations = new ReverseRelationsCollection([], {
            params: [
                {key: 'parentId', value: this.id},
                {key: 'type.parentType', value: 'organization'},
                {key: 'type.childType', value: 'person'}
            ]
        });
        this.permissions = sessionChannel.request('get:permissions');
        this.byAdmin = options.byAdmin;
        this.isSelf = options.isSelf;
        this.utils = new CommonUtils();
    },

    onErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        window.document.title = this.model.get("name");
        var that = this;
        that.initEvents();
        this.ui.leftTabs.hide();
        that.renderPerson();

        that.$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var target = that.$(e.target).attr("href");
            if ((target == '#medical-records' || target == '#medications-content')/* && that.medicalRecords == undefined*/) {
                that.medicalRecords = new MedicalRecords({
                    personId: that.model.get('id'),
                    name: that.model.get('name'),
                    canEdit: that.canEdit()
                });
                that.showChildView('medicalRecords', that.medicalRecords);
            } else if (target == '#diseases-content') {
                that.diseasesView = new DiseasesView({
                    medProfileModel: that.medProfileModel,
                    name: that.model.get('name'),
                    canEdit: that.canEdit()
                });
                that.showChildView('diseasesRegion', that.diseasesView);
            } else if (target == '#visits-content') {
            } else if (target == '#documents-content') {
                that.documentsView = new PatientDocuments({
                    medProfileModel: that.medProfileModel,
                    name: that.model.get('name'),
                    canEdit: that.canEdit()
                });
                that.showChildView('documentsRegion', that.documentsView);
            } else if (target == '#appendix-kk-content') {
                that.determinationOfNeedRevisedOriginal = that.utils.deepClone(that.medProfileModel.get('object').determinationOfNeedRevised || []);
                if ((that.medProfileModel.get('object').determinationOfNeedRevised || []).length < 15) {
                    that.medProfileModel.get('object').determinationOfNeedRevised = that.utils.getDeterminationOfNeedRevised();
                }
                that.appendixKKView = new DeterminationOfNeedRevisedView({
                    determinationOfNeedRevised: that.medProfileModel.get('object').determinationOfNeedRevised,
                    isEditMode: that.canEdit()
                });
                that.showChildView('appendixKKRegion', that.appendixKKView);
                that.checkAppendixKKSaveBtn();
            } else if (target == '#sources-content') {
                that.sourcesView = new PatientSources({
                    medProfileModel: that.medProfileModel,
                    name: that.model.get('name'),
                    canEdit: that.canEdit()
                });
                that.showChildView('sourcesRegion', that.sourcesView);
            } else if (target == '#immunizations-content' && _.isUndefined(that.immunizationsView)) {
                that.immunizationsView = new PatientImmunizations({
                    medProfileModel: that.medProfileModel,
                    patient: that.model.get('object'),
                    name: that.model.get('name'),
                    canEdit: that.canEdit()
                });
                that.showChildView('immunizationsRegion', that.immunizationsView);
            } else if (target == '#dicoms-content') {
                console.log("dicoms");
                that.dicomsView = new PatientDicoms({patient: that.model.get('object')});
                that.showChildView('dicomsRegion', that.dicomsView);
            } else if (target == '#vitals-content' /*&& _.isUndefined(that.vitalsView)*/) {
                that.vitalsView = new PatientVitals({
                    medProfileModel: that.medProfileModel,
                    patient: that.model.get('object'),
                    name: that.model.get('name'),
                    canEdit: that.canEdit()
                });
                that.showChildView('vitalsRegion', that.vitalsView);
            } else if (target == '#person-comments' && typeof that.getChildView('comments') == 'undefined') {
                that.renderCommentsView();
            }

            //$('.nav-tabs a[href="' + target + '"]').tab('show');
        });
        //this.parentOrganizationsRelations.fetch({success: this.renderParentRelations});
    },

    initEvents: function () {
        this.triggerMethod('comment:count:changed');
    },

    renderPerson: function () {
        if (this.canEdit()) {
            this.personForm = new PersonForm({model: this.model, isEditMode: true, byAdmin: this.byAdmin});
            this.showChildView('personForm', this.personForm);
        }

        this.showChildView('personData', new PersonDataView({
            model: this.model,
            byAdmin: this.byAdmin,
            isSelf: this.isSelf,
            canEdit: this.canEdit()
        }));

        this.renderContacts();
        this.renderAddresses();
        this.renderRepresentatives();
        this.renderOrganizationsView(this.model);

        if (this.canEdit()) {
            this.permissionsCollection = new PermissionsCollection([], {
                params: [{
                    key: 'permittedObjectId',
                    value: this.model.id
                }]
            });

            this.renderPermissionsListView(this.permissionsCollection);

            this.permissionFormView = new PermissionFormView({
                'permittedObjectId': this.model.id,
                showOrganization: true,
                permittedObjectType: 'person'
            });
            this.showChildView('addPermission', this.permissionFormView);

            this.renderExternalIdsView(this.model.get('object').externalIds || []);
        }
    },

    renderParentRelations: function () {
        this.showChildView('organizationRelations', new RelationsListView({collection: this.parentOrganizationsRelations}));
    },

    renderPermissionsListView: function (collection) {
        this.permissionsListView = new PermissionsTableView({
            collection: collection,
            showOrganization: true,
            permittedObjectType: 'person'
        });
        this.showChildView('permissions', this.permissionsListView);
    },

    renderCommentsView: function () {

        this.commentModel = new Backbone.Model({
            id: undefined,
            text: undefined
        });

        this.showChildView('comments', new CommentsTableView({
            dboId: this.model.get('id'),
            canEdit: this.canEdit()
        }));

        this.renderCommentForm();
    },

    renderCommentForm: function (model) {
        this.showChildView('addComment', new CommentFormView({
            dboId: this.model.get('id'),
            model: model ? model : new Backbone.Model({
                id: undefined,
                text: undefined
            })
        }));
    },

    renderExternalIdsView: function(externalIds) {
        this.externalIdsView = new ExternalIdsView({
            externalIds: _.clone(externalIds)
        });
        this.showChildView('externalsIdsRegion', this.externalIdsView);
    },

    renderOrganizationsView: function(model) {
        this.organizationsView = new PersonOrganizationsView({
            personModel: model,
            canEdit: this.canEdit()
        });
        this.showChildView('organizationsRegion', this.organizationsView);
    },

    toggleEdit: function () {
        if (this.canEdit()) {
            this.ui.personData.toggle();
            this.$('#edit-section').toggle();
        }
    },

    saveChanges: function () {
        var that = this;
        that.model = that.personForm.fillModel();
        that.model.save(that.model.toJSON(), {
            success: function (response) {
                that.toggleEdit();
                that.renderContacts();
                that.renderAddresses();
                that.renderRepresentatives();
            },
            error: function (model, xhr, options) {
                notificationsChannel.request('show:notification', xhr.responseText);
            }
        });
    },

    orgRelationSaved: function (event) {
        this.parentOrganizationsRelations.add(event);
        this.showBlankOrgRelationsForm();
    },

    showBlankOrgRelationsForm: function () {
        this.orgRelationsFormView = new RelationsFormView({
            entity: this.model.id,
            reversed: true,
            childrenTypes: ['person'],
            parentTypes: ['organization']
        });
        this.listenTo(this.orgRelationsFormView, 'relation:saved', this.orgRelationSaved);
        this.showChildView('addOrganizationRelation', this.orgRelationsFormView);
    },

    permissionSaved: function (model) {
        this.renderPermissionsListView(this.permissionsCollection);
    },

    canEdit: function () {
        if (typeof this.userCanEdit == "undefined") {
            this.userCanEdit = this.utils.userCanDo(this.permissions || [],
                function (permission) {
                    return permission.canWriteFor;
                },
                this.model.get('permissions') || [],
                function (permission) {
                    return permission.canWrite;
                }
            );
        }
        return this.userCanEdit;
    },

    savePersonBtnEnableOrDisable: function (data) {
        if (data.result)
            this.ui.saveBtn.removeAttr("disabled");
        else
            this.ui.saveBtn.attr("disabled", "true");
    },

    renderContacts: function () {
        this.contactsView = new ContactsTableView({
            collection: new ContactsCollection(this.model.get('object').contacts),
            canEdit: this.canEdit()
        });
        this.showChildView("contacts", this.contactsView);
    },

    renderAddresses: function () {
        this.addressesView = new AddressTableView({
            collection: new ContactsCollection(this.model.get('object').addresses),
            canEdit: this.canEdit()
        });
        this.showChildView("addresses", this.addressesView);
    },

    renderRepresentatives: function () {
        this.representativesView = new RepresentativesTableView({
            collection: new ContactsCollection(this.model.get('object').representatives),
            canEdit: this.canEdit()
        });
        this.showChildView("representatives", this.representativesView);
    },

    renderContactForm: function (mode, contact) {
        this.ui.contactForm.show();
        if (mode == 'add') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                addresses: this.model.get('object').addresses || [],
                representatives: this.model.get('object').representatives || []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
        else if (mode == 'edit') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                contact: contact,
                addresses: this.model.get('object').addresses || [],
                representatives: this.model.get('object').representatives || []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
    },

    renderAddressForm: function (mode, address) {
        if (mode == 'add') {
            this.addressFormView = new AddressesFormView({
                mode: mode
            });
            this.showChildView("addressForm", this.addressFormView);
        }
        else if (mode == 'edit') {
            this.addressFormView = new AddressesFormView({
                mode: mode,
                address: address
            });
            this.showChildView("addressForm", this.addressFormView);
        }
    },

    renderRepresentativeForm: function (mode, representative) {
        if (mode == 'add') {
            this.representativeFormView = new RepresentativeFormView({
                mode: mode
            });
            this.showChildView("representativeForm", this.representativeFormView);
        }
        else if (mode == 'edit') {
            this.representativeFormView = new RepresentativeFormView({
                mode: mode,
                representative: representative
            });
            this.showChildView("representativeForm", this.representativeFormView);
        }
    },

    removeContactForm: function () {
        this.ui.contactForm.hide();
        this.detachChildView('contactForm');
    },

    removeAddressForm: function () {
        this.detachChildView('addressForm');
    },

    removeRepresentativeForm: function () {
        this.ui.representativeForm.hide();
        this.detachChildView('representativeForm');
    },

    onContactAction: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.renderContactForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemoveContact = data.data.attributes;
            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data !== willBeRemoveContact.data
                    || contact.type !== willBeRemoveContact.type
                    || contact.preferred !== willBeRemoveContact.preferred;
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedContact = data.data.attributes;
            var willEditContact = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data == willBeEditedContact.data
                    && contact.type == willBeEditedContact.type
                    && contact.preferred == willBeEditedContact.preferred;
            });
            this.renderContactForm(data.mode, willEditContact[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeContactForm();
        } else if (data.mode == 'save') {
            var changedContact = data.data.attributes;
            (that.model.get('object').contacts || []).forEach(function (contact) {
                if (contact.data == changedContact.data
                    && contact.type == changedContact.type) {
                    contact.preferred = changedContact.preferred;
                }
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                }
            });
        }
    },

    onContactSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.data !== data.contact.data
                    || contact.type !== data.contact.type
                    || contact.preferred !== data.contact.preferred;
            });
            that.model.get('object').contacts.push(data.contact);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                    that.removeContactForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderContacts();
                    that.removeContactForm();
                }
            });
        }
    },

    onAddressAction: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.renderAddressForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemovedAddress = data.data.attributes;
            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
                return address.uuid !== willBeRemovedAddress.uuid;
            });
            that.model.get('object').contacts.forEach(function (contact) {
                contact.addresses = (contact.addresses || []).filter(function (addressUuid) {
                    return addressUuid != willBeRemovedAddress.uuid;
                })
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderAddresses();
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedAddress = data.data.attributes;
            var willEditAddress = (that.model.get('object').addresses || []).filter(function (address) {
                return address.uuid == willBeEditedAddress.uuid;
            });
            this.renderAddressForm(data.mode, willEditAddress[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeAddressForm();
        }
    },

    onAddressSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
                return address !== null && address.uuid !== data.address.uuid;
            });
            that.model.get('object').addresses.push(data.address);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderAddresses();
                    that.renderContacts();
                    that.removeAddressForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderAddresses();
                    that.renderContacts();
                    that.removeAddressForm();
                }
            });
        }
    },

    onRepresentativeAction: function(data) {
        var that = this;
        if (data.mode == 'add') {
            this.ui.representativeForm.show();
            that.renderRepresentativeForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemovedRepresentative = data.data.attributes;
            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
                return representative.uuid !== willBeRemovedRepresentative.uuid;
            });
            that.model.get('object').contacts.forEach(function (contact) {
                contact.representatives = (contact.representatives || []).filter(function (representativeUuid) {
                    return representativeUuid != willBeRemovedRepresentative.uuid;
                })
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderRepresentatives();
                    that.renderContacts();
                }
            });
        }
        else if (data.mode == 'edit') {
            var willBeEditedRepresentative = data.data.attributes;
            var willEditRepresentative = (that.model.get('object').representatives || []).filter(function (representative) {
                return representative.uuid == willBeEditedRepresentative.uuid;
            });
            this.ui.representativeForm.show();
            this.renderRepresentativeForm(data.mode, willEditRepresentative[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeRepresentativeForm();
        }
    },

    onRepresentativeSaved: function(data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
                return representative !== null && representative.uuid !== data.representative.uuid;
            });
            that.model.get('object').representatives.push(data.representative);
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderRepresentatives();
                    that.renderContacts();
                    that.removeRepresentativeForm();
                }
            });
        } else if (data.mode == 'edit') {
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderRepresentatives();
                    that.renderContacts();
                    that.removeRepresentativeForm();
                }
            });
        }
    },

    onContactHover: function (data) {

        $('.address-row').each(function () {
            $(this).children().each(function () {
                $(this).removeClass('hovered-contact-marked');
            });
        });

        $('.representative-row').each(function () {
            $(this).children().each(function () {
                $(this).removeClass('hovered-contact-marked');
            });
        });

        (data.addresses || []).forEach(function (addressUuid) {
            $('.' + addressUuid).each(function () {
                if (data.hovered) {
                    $(this).addClass('hovered-contact-marked');
                } else {
                    $(this).removeClass('hovered-contact-marked');
                }
            });
        });

        (data.representatives || []).forEach(function (representativeUuid) {
            $('.' + representativeUuid).each(function () {
                if (data.hovered) {
                    $(this).addClass('hovered-contact-marked');
                } else {
                    $(this).removeClass('hovered-contact-marked');
                }
            });
        });
    },

    onAddressHover: function (event) {

        $('.contact-row').each(function () {
            $(this).removeClass('hovered-contact-marked');
        });

        this.model.get('object').contacts.forEach(function (contact, index) {
            if ((contact.addresses || []).indexOf(event.uuid) > -1) {
                if (event.hovered) {
                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
                } else {
                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
                }
            }
        });
    },

    onRepresentativeHover: function(event) {

        $('.contact-row').each(function () {
            $(this).removeClass('hovered-contact-marked');
        });

        this.model.get('object').contacts.forEach(function (contact, index) {
            if ((contact.representatives || []).indexOf(event.uuid) > -1) {
                if (event.hovered) {
                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
                } else {
                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
                }
            }
        });
    },

    isItOwn: function () {
        return this.model.get('id') == this.permissions.userId;
    },

    reRenderMedProfile: function () {
        this.getChildView('medicalRecords').render();
    },

    showLeftSubTabs: function (model) {
        this.medProfileModel = model;
        this.ui.leftTabs.show();
    },

    checkAppendixKKSaveBtn: function () {
        if (_.isEqual(this.determinationOfNeedRevisedOriginal, this.medProfileModel.get('object').determinationOfNeedRevised || []))
            this.ui.saveAppendixKKBtn.attr('disabled', true);
        else
            this.ui.saveAppendixKKBtn.removeAttr('disabled');
    },

    onDonRChanged: function () {
        this.checkAppendixKKSaveBtn();
    },

    onSaveAppendixKK: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "PUT",
            url: '/api/medprofile/' + that.medProfileModel.get('id') + '/appendix_kk',
            data: JSON.stringify(that.medProfileModel.get('object').determinationOfNeedRevised),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.medProfileModel.get('object').determinationOfNeedRevised = response.object.determinationOfNeedRevised || [];
                    that.determinationOfNeedRevisedOriginal = that.utils.deepClone(that.medProfileModel.get('object').determinationOfNeedRevised || []);
                    that.appendixKKView = new DeterminationOfNeedRevisedView({
                        determinationOfNeedRevised: that.medProfileModel.get('object').determinationOfNeedRevised,
                        isEditMode: true
                    });
                    that.showChildView('appendixKKRegion', that.appendixKKView);
                    that.checkAppendixKKSaveBtn();
                }
            },
            error: function (e) {
                notificationsChannel.request('show:notification', e.responseJSON);
                that.utils.hideSpinner();
            }
        });
    },

    onCommentAdded: function (commentModel) {
        this.getChildView('comments').add(commentModel);
        this.renderCommentForm();
    },

    onCommentUpdated: function (commentModel) {
        this.getChildView('comments').update(commentModel);
        this.renderCommentForm();
    },

    onCommentCountChanged: function () {
        var that = this;

        $.ajax({
            type: "GET",
            url: '/api/comment/' + that.model.get('id') + '/count',
            statusCode: {
                200: function (response) {
                    that.ui.commentsCount.text(response);
                    if (typeof that.getChildView('comments') != 'undefined') {
                        that.getChildView('comments').syncWithCount(response);
                    }
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    },

    onCancelCommentSend: function () {
        this.renderCommentForm();
    },

    onEditComment: function (model) {
        this.renderCommentForm(model);
        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
    },

    onNewComment: function () {
        this.renderCommentForm();
        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
    },

    onSavePersonExternalIds: function(data) {
        var that = this;
        var idsList = data.externalIds;
        var doSave = data.doSave;

        if (doSave) {
            that.model.get('object').externalIds = _.reject(idsList, function(id) {
                return _.isEmpty(id);
            });
            that.model.save(that.model.toJSON(), {
                success: function () {
                    that.renderExternalIdsView(that.model.get('object').externalIds || []);
                    $.notify("External ids saved successfully", "success");
                },
                error: function (collection, response, options) {
                    if (response.status == 401) {
                        actionsChannel.request("redirect:to:login");
                    } else {
                        notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
                    }
                }
            });
        } else {
            that.renderExternalIdsView(idsList);
        }
    },

    onCancelPersonExternalIds: function() {
        this.renderExternalIdsView(this.model.get('object').externalIds || []);
    }
});

module.exports = PersonView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/person-view.js
// module id = 344
// module chunks = 0